/**
 * Shared utility functions for status badges
 * Used across different epics (adminManagment, subscriptionManagment, etc.)
 */

export type StatusValue = 'active' | 'inactive' | 'cascaded';

/**
 * Gets the status label in Polish
 */
export const getStatusLabel = (
  status: StatusValue | null | undefined
): string => {
  if (status === 'active') {
    return 'Aktywny';
  }
  if (status === 'inactive' || status === 'cascaded') {
    return 'Nieaktywny';
  }
  return '—';
};

/**
 * Gets status badge classes based on status
 */
export const getStatusBadgeClasses = (
  status: StatusValue | null | undefined
): { container: string; dot: string } => {
  const isActive = status === 'active';
  return {
    container: isActive
      ? 'bg-success-90 text-success-30'
      : 'bg-[#E5E7E9] text-[#878B8E]',
    dot: isActive ? 'bg-success-40' : 'bg-[#878B8E]',
  };
};
